import React from "react";
import AceEditor from "react-ace";

function FacturaXml(props) {
  const { customer, shippingAddress_obj, notes, name, billing_address } =
    props.data[0];
  const address = shippingAddress_obj
    ? shippingAddress_obj.state.split(",")
    : "";
  const addressPlus = address ? address[2]?.split(" ") : "";

  const data = `
  <cfdi:Comprobante xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:cce11="http://www.sat.gob.mx/ComercioExterior11" xmlns:cfdi="http://www.sat.gob.mx/cfd/3" xsi:schemaLocation="http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd http://www.sat.gob.mx/ComercioExterior11 http://www.sat.gob.mx/sitio_internet/cfd/ComercioExterior11/ComercioExterior11.xsd" Version="3.3" Serie="A" Folio="1387" Fecha="2022-06-01T08:33:49" Sello="XJOqDoIzEOMGcBndDeb+DJ/PnjvRpS9lYZ2+KvkGZuRkjRG/vEJfD8akdkpr5buKVVA2HmjYEgIw8hyIMFOl/2EwDugrvTtpPSdp9i5/EsHX1D3neAtWcjT6P8zhfZ1sHUkMfbzW134cWQWBTk6h8pE8ypS+Kg6aQeM5BoL5CdDf2rCklzxU69S14V0y4U6AOjPsogu3+pkWHgWI0GgAQqR4KtlUCTPjE8n/LT88Ide0i6a80jEPbPMqPtPcKV8diQ6WLqbxyfPbbw6mag+uNhqBm1897aWrVWCu+f4e/vU6w1o+aGsQExQ2Z/UBdVWuXGrQ7+yNvDqX8qcadV48Hw==" NoCertificado="00001000000411544049" Certificado="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" SubTotal="0" Moneda="USD" TipoCambio="19.50" Total="0" TipoDeComprobante="T" LugarExpedicion="72830">
<cfdi:Emisor Rfc="ACO130226GP4" Nombre="${
    customer.name ? customer.name : customer.first_name
  }" RegimenFiscal="622"/>
<cfdi:Receptor Rfc="XEXX010101000" Nombre="${
    customer.name ? customer.name : customer.first_name
  }" ResidenciaFiscal="CAN" NumRegIdTrib="911457425" UsoCFDI="P01"/>
<cfdi:Conceptos>
<cfdi:Concepto ClaveUnidad="XBX" ClaveProdServ="50402300" NoIdentificacion="50402300" Cantidad="1" Unidad="CAJAS" Descripcion="${
    notes ? notes : name
  }" ValorUnitario="15" Importe="1725"/>
</cfdi:Conceptos>
<cfdi:Complemento>
<cce11:ComercioExterior Version="1.1" MotivoTraslado="99" TipoOperacion="2" ClaveDePedimento="A1" CertificadoOrigen="0" Incoterm="DAP" Subdivision="0" TipoCambioUSD="19.50" TotalUSD="16230.00">
<cce11:Emisor>
<cce11:Domicilio Calle="10025 Siempre Viva Rd" NumeroExterior="121" Localidad="07" Municipio="San diego" Estado="CA" Pais="US" CodigoPostal="72830"/>
</cce11:Emisor>
<cce11:Receptor>
<cce11:Domicilio Calle="${
    address[0] ? address[0] : billing_address.address1
  }" Colonia=" 438" Municipio="${
    address[1] ? address[1] : billing_address.city
  }" Estado="${
    addressPlus[1] ? addressPlus[1] : billing_address.province_code
  }" Pais="US" CodigoPostal="${
    addressPlus[2] ? addressPlus[2] : billing_address.zip
  }"/>
</cce11:Receptor>
<cce11:Mercancias>
<cce11:Mercancia NoIdentificacion="50404001" FraccionArancelaria="1211909999" CantidadAduana="1380" UnidadAduana="01" ValorUnitarioAduana="2.75" ValorDolares="3795.00"/>
<cce11:Mercancia NoIdentificacion="50402300" FraccionArancelaria="0704909999" CantidadAduana="2211.541" UnidadAduana="01" ValorUnitarioAduana="0.78" ValorDolares="1725.00"/>
<cce11:Mercancia NoIdentificacion="50403001" FraccionArancelaria="0704909999" CantidadAduana="1225.610" UnidadAduana="01" ValorUnitarioAduana="0.82" ValorDolares="1005.00"/>
<cce11:Mercancia NoIdentificacion="50402600" FraccionArancelaria="0704100399" CantidadAduana="1988.636" UnidadAduana="01" ValorUnitarioAduana="1.32" ValorDolares="2625.00"/>
<cce11:Mercancia NoIdentificacion="50406200" FraccionArancelaria="0709700100" CantidadAduana="563.639" UnidadAduana="01" ValorUnitarioAduana="1.65" ValorDolares="930.00"/>
<cce11:Mercancia NoIdentificacion="50402700" FraccionArancelaria="0709400299" CantidadAduana="3181.818" UnidadAduana="01" ValorUnitarioAduana="0.66" ValorDolares="2100.00"/>
<cce11:Mercancia NoIdentificacion="50403000" FraccionArancelaria="0705110100" CantidadAduana="3068.182" UnidadAduana="01" ValorUnitarioAduana="1.32" ValorDolares="4050.00"/>
</cce11:Mercancias>
</cce11:ComercioExterior>
<tfd:TimbreFiscalDigital xmlns:tfd="http://www.sat.gob.mx/TimbreFiscalDigital" Version="1.1" RfcProvCertif="STA0903206B9" UUID="AFA49EA9-4CFC-4562-A83E-F44175A87B30" FechaTimbrado="2022-06-01T09:20:58" SelloCFD="XJOqDoIzEOMGcBndDeb+DJ/PnjvRpS9lYZ2+KvkGZuRkjRG/vEJfD8akdkpr5buKVVA2HmjYEgIw8hyIMFOl/2EwDugrvTtpPSdp9i5/EsHX1D3neAtWcjT6P8zhfZ1sHUkMfbzW134cWQWBTk6h8pE8ypS+Kg6aQeM5BoL5CdDf2rCklzxU69S14V0y4U6AOjPsogu3+pkWHgWI0GgAQqR4KtlUCTPjE8n/LT88Ide0i6a80jEPbPMqPtPcKV8diQ6WLqbxyfPbbw6mag+uNhqBm1897aWrVWCu+f4e/vU6w1o+aGsQExQ2Z/UBdVWuXGrQ7+yNvDqX8qcadV48Hw==" NoCertificadoSAT="00001000000506204896" SelloSAT="s61mWLy+C8NLNzJipXONLZKax7KdMtCESAZwNZPuIIpzi4Tog5f1AlslkCeaj37uBxvbntXC4BqP6+7/ny91tHoHfNbYtddywdu+iojBGaDuf7iIv0n7xcVmIPEd5RFXwBKO1JY+JJv4jy+hA8xO70Vhxl+RBnAOtZNvD8aDKK7xvRa7ayCpV/MQKC4i/kiC6uTNAmLGTVgK1jgUngO7rCY3bywJCyILDzgJCqi4e+HtvwugMw0fDV52YcvUz1cl/knKm82iQMolDxrZU5Sbw3ynv+JTjDXlxNtqJc7zvyQSg+s3l0Lli6rYY87cFRE1z3JaRfWGAkogd67CSFiLMw==" xsi:schemaLocation="http://www.sat.gob.mx/TimbreFiscalDigital http://www.sat.gob.mx/sitio_internet/cfd/TimbreFiscalDigital/TimbreFiscalDigitalv11.xsd"/>
</cfdi:Complemento>
</cfdi:Comprobante>
  `;

  return (
    <div
      className="mt-2 w-full h-full pb-10 pr-10 pl-10"
      style={{
        overflowY: "scroll",
        wordWrap: "break-word",
        marginBottom: 20,
      }}
    >
      <AceEditor
        width="100%"
        height="100%"
        mode="javascript"
        theme="tomorrow"
        name="editor"
        value={data}
        fontSize={14}
        editorProps={{ $blockScrolling: true }}
      />
      {/* <div>{`<cfdi:comprobante`}</div>
      <div>{`xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"`}</div>
      <div>{`xmlns:cce11="http://www.sat.gob.mx/ComercioExterior11"`}</div>
      <div>{`xsi:schemalocation="http://www.sat.gob.mx/cfd/3`}</div>
      <div>{` http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd http://www.sat.gob.mx/ComercioExterior11 http://www.sat.gob.mx/sitio_internet/cfd/ComercioExterior11/ComercioExterior11.xsd"`}</div>
      <div>{` version="3.3"`}</div>
      <div>{`serie="A"`}</div>
      <div>{`  folio={1387}`}</div>
      <div>{`fecha="2022-06-01T08:33:49"`}</div>
      <div>{`sello="XJOqDoIzEOMGcBndDeb+DJ/PnjvRpS9lYZ2+KvkGZuRkjRG/vEJfD8akdkpr5buKVVA2HmjYEgIw8hyIMFOl/2EwDugrvTtpPSdp9i5/EsHX1D3neAtWcjT6P8zhfZ1sHUkMfbzW134cWQWBTk6h8pE8ypS+Kg6aQeM5BoL5CdDf2rCklzxU69S14V0y4U6AOjPsogu3+pkWHgWI0GgAQqR4KtlUCTPjE8n/LT88Ide0i6a80jEPbPMqPtPcKV8diQ6WLqbxyfPbbw6mag+uNhqBm1897aWrVWCu+f4e/vU6w1o+aGsQExQ2Z/UBdVWuXGrQ7+yNvDqX8qcadV48Hw=="`}</div>
      <div>{`nocertificado={00001000000411544049}`}</div>
      <div>{`certificado="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"`}</div>
      <div>{`subtotal={10}`}</div>
      <div>{`moneda="USD"`}</div>
      <div>{`tipocambio="19.50"`}</div>
      <div>{`total={10}`}</div>
      <div>{`tipodecomprobante="T"`}</div>
      <div>{`lugarexpedicion={72830}`}</div>
      <div>{`xmlns:cfdi="http://www.sat.gob.mx/cfd/3"`}</div>
      <div>{`>`}</div>
      <div>{` <cfdi:emisor`}</div>
      <div>{`rfc="ACO130226GP4"`}</div>
      <div>{`nombre="${
        customer.name ? customer.name : customer.first_name
      }"`}</div>
      <div>{`regimenfiscal={622}`}</div>
      <div>{` >`}</div>
      <div>{`<cfdi:receptor`}</div>
      <div>{`rfc="XEXX010101000"`}</div>
      <div>{`nombre="${
        customer.name ? customer.name : customer.first_name
      }"`}</div>
      <div>{`residenciafiscal="CAN"`}</div>
      <div>{`numregidtrib={911457425}`}</div>
      <div>{`usocfdi="P01"`}</div>
      <div>{`>`}</div>
      <div>{`<cfdi:conceptos>`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50402300}`}</div>
      <div>{`noidentificacion={50402300}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{`>`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50404001}`}</div>
      <div>{`noidentificacion={50404001}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{`>`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50406200}`}</div>
      <div>{`noidentificacion={50406200}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{`>`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50403001}`}</div>
      <div>{`noidentificacion={50403001}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{` >`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50402600}`}</div>
      <div>{`noidentificacion={50402600}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{` valorunitario={10}`}</div>
      <div>{` importe={10}`}</div>
      <div>{`>`}</div>
      <div>{` <cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{`claveprodserv={50402700}`}</div>
      <div>{`noidentificacion={50402700}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{` >`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveunidad="XBX"`}</div>
      <div>{` claveprodserv={50403000}`}</div>
      <div>{`noidentificacion={50403000}`}</div>
      <div>{`cantidad={1}`}</div>
      <div>{`unidad="CAJAS"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10}`}</div>
      <div>{`importe={10}`}</div>
      <div>{`/>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{` </cfdi:concepto>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{`</cfdi:conceptos>`}</div>
      <div>{`<cfdi:complemento>`}</div>
      <div>{`<cce11:comercioexterior`}</div>
      <div>{`version="1.1"`}</div>
      <div>{` motivotraslado={99}`}</div>
      <div>{`tipooperacion={2}`}</div>
      <div>{`clavedepedimento="A1"`}</div>
      <div>{`certificadoorigen={0}`}</div>
      <div>{`incoterm="DAP"`}</div>
      <div>{`subdivision={0}`}</div>
      <div>{`tipocambiousd="19.50"`}</div>
      <div>{`totalusd={10.0}`}</div>
      <div>{` >`}</div>
      <div>{` <cce11:emisor>`}</div>
      <div>{`<cce11:domicilio`}</div>
      <div>{`calle="10025 Siempre Viva Rd"`}</div>
      <div>{`numeroexterior={121}`}</div>
      <div>{`localidad={07}`}</div>
      <div>{`municipio="San Diego"`}</div>
      <div>{`estado="CA"`}</div>
      <div>{`pais="US"`}</div>
      <div>{` codigopostal={92154}`}</div>
      <div>{`/>`}</div>
      <div>{`</cce11:emisor>`}</div>
      <div>{`<cce11:receptor>`}</div>
      <div>{`<cce11:domicilio`}</div>
      <div>{`calle="${
        address[0] ? address[0] : billing_address.address1
      }"`}</div>
      <div>{`colonia=""`}</div>
      <div>{`municipio="${
        address[1] ? address[1] : billing_address.city
      }"`}</div>
      <div>{`estado="${
        addressPlus[1] ? addressPlus[1] : billing_address.province_code
      }"`}</div>
      <div>{` pais="US"`}</div>
      <div>{`codigopostal="${
        addressPlus[2] ? addressPlus[2] : billing_address.zip
      }"`}</div>
      <div>{`/>`}</div>
      <div>{` </cce11:receptor>`}</div>
      <div>{`<cce11:mercancias>`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{`noidentificacion={50404001}`}</div>
      <div>{`fraccionarancelaria={1211909999}`}</div>
      <div>{`cantidadaduana={1380}`}</div>
      <div>{` unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="2.75"`}</div>
      <div>{`valordolares={3795.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{`noidentificacion={50402300}`}</div>
      <div>{`fraccionarancelaria={0704909999}`}</div>
      <div>{`cantidadaduana="2211.541"`}</div>
      <div>{`unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="0.78"`}</div>
      <div>{`valordolares={1725.0}`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{`noidentificacion={50403001}`}</div>
      <div>{`fraccionarancelaria={0704909999}`}</div>
      <div>{` cantidadaduana="1225.610"`}</div>
      <div>{`unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="0.82"`}</div>
      <div>{`valordolares={1005.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{` noidentificacion={50402600}`}</div>
      <div>{`fraccionarancelaria={0704100399}`}</div>
      <div>{`cantidadaduana="1988.636"`}</div>
      <div>{`unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="1.32"`}</div>
      <div>{`valordolares={2625.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{`noidentificacion={50406200}`}</div>
      <div>{`fraccionarancelaria={0709700100}`}</div>
      <div>{`cantidadaduana="563.639"`}</div>
      <div>{` unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="1.65"`}</div>
      <div>{`valordolares={930.0}`}</div>
      <div>{`>`}</div>
      <div>{` <cce11:mercancia`}</div>
      <div>{`noidentificacion={50402700}`}</div>
      <div>{`fraccionarancelaria={0709400299}`}</div>
      <div>{` cantidadaduana="3181.818"`}</div>
      <div>{`unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="0.66"`}</div>
      <div>{`valordolares={2100.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cce11:mercancia`}</div>
      <div>{`noidentificacion={50403000}`}</div>
      <div>{`fraccionarancelaria={0705110100}`}</div>
      <div>{`cantidadaduana="3068.182"`}</div>
      <div>{`unidadaduana={01}`}</div>
      <div>{`valorunitarioaduana="1.32"`}</div>
      <div>{` valordolares={4050.0}`}</div>
      <div>{`/>`}</div>
      <div>{` </cce11:mercancia>`}</div>
      <div>{`</cce11:mercancia>`}</div>
      <div>{`</cce11:mercancia>`}</div>
      <div>{` </cce11:mercancia>`}</div>
      <div>{`</cce11:mercancia>`}</div>
      <div>{`</cce11:mercancia>`}</div>
      <div>{`</cce11:mercancias>`}</div>
      <div>{` </cce11:comercioexterior>`}</div>
      <div>{`<tfd:timbrefiscaldigital`}</div>
      <div>{`version="1.1"`}</div>
      <div>{`rfcprovcertif="STA0903206B9"`}</div>
      <div>{`uuid="AFA49EA9-4CFC-4562-A83E-F44175A87B30"`}</div>
      <div>{`fechatimbrado="2022-06-01T09:20:58"`}</div>
      <div>{`sellocfd="XJOqDoIzEOMGcBndDeb+DJ/PnjvRpS9lYZ2+KvkGZuRkjRG/vEJfD8akdkpr5buKVVA2HmjYEgIw8hyIMFOl/2EwDugrvTtpPSdp9i5/EsHX1D3neAtWcjT6P8zhfZ1sHUkMfbzW134cWQWBTk6h8pE8ypS+Kg6aQeM5BoL5CdDf2rCklzxU69S14V0y4U6AOjPsogu3+pkWHgWI0GgAQqR4KtlUCTPjE8n/LT88Ide0i6a80jEPbPMqPtPcKV8diQ6WLqbxyfPbbw6mag+uNhqBm1897aWrVWCu+f4e/vU6w1o+aGsQExQ2Z/UBdVWuXGrQ7+yNvDqX8qcadV48Hw=="`}</div>
      <div>{`nocertificadosat={00001000000506204896}`}</div>
      <div>{`sellosat="s61mWLy+C8NLNzJipXONLZKax7KdMtCESAZwNZPuIIpzi4Tog5f1AlslkCeaj37uBxvbntXC4BqP6+7/ny91tHoHfNbYtddywdu+iojBGaDuf7iIv0n7xcVmIPEd5RFXwBKO1JY+JJv4jy+hA8xO70Vhxl+RBnAOtZNvD8aDKK7xvRa7ayCpV/MQKC4i/kiC6uTNAmLGTVgK1jgUngO7rCY3bywJCyILDzgJCqi4e+HtvwugMw0fDV52YcvUz1cl/knKm82iQMolDxrZU5Sbw3ynv+JTjDXlxNtqJc7zvyQSg+s3l0Lli6rYY87cFRE1z3JaRfWGAkogd67CSFiLMw=="`}</div>
      <div>{`xmlns:tfd="http://www.sat.gob.mx/TimbreFiscalDigital"`}</div>
      <div>{`xsi:schemalocation="http://www.sat.gob.mx/TimbreFiscalDigital http://www.sat.gob.mx/sitio_internet/cfd/TimbreFiscalDigital/TimbreFiscalDigitalv11.xsd"`}</div>
      <div>{`/>`}</div>
      <div>{`</cfdi:complemento>`}</div>
      <div>{` </cfdi:receptor>`}</div>
      <div>{`</cfdi:emisor>`}</div>
      <div>{`</cfdi:comprobante>`}</div> */}
    </div>
  );
}

export default FacturaXml;
